import { MachinesListSupportSessionsZitadelRoleTypes } from "@common/types/machines-list-types";

interface ActiveOtherUserViewParams {
  zitadelRole: MachinesListSupportSessionsZitadelRoleTypes;
  isCurrentUserSessionOwner: boolean;
}

export const isActiveOtherUserView = ({
  zitadelRole,
  isCurrentUserSessionOwner,
}: ActiveOtherUserViewParams): boolean => {
  return (
    zitadelRole === MachinesListSupportSessionsZitadelRoleTypes.REQUEST_VPN &&
    !isCurrentUserSessionOwner
  );
};
